import React from "react";

type InputProps = {
  value?: string;
  onChange?: React.ChangeEventHandler<HTMLInputElement>;
  type?: React.HTMLInputTypeAttribute | undefined;
  disabled?: boolean;
  placeholder?: string;
  name?: string;
  className?:string;
  maxLength?:number;
  required?:boolean
  onKeyDown?:React.KeyboardEventHandler<HTMLInputElement>;
};

const Input = ({
  value,
  onChange,
  type = "text",
  disabled = false,
  placeholder = "",
  maxLength,
  name,
  className,
  required ,
  onKeyDown
}: InputProps) => {
  return (
    <input
      type={type}
      onChange={onChange}
      disabled={disabled}
      value={value}
      placeholder={placeholder}
      className={`w-full  bg-[#F2F2F2] focus:border-sky-500 focus:outline  p-2  rounded-lg mt-1 ${className}`}
      name={name}
      maxLength={maxLength}
      required={required}
      onKeyDown={onKeyDown}
    />
  );
};

export default Input;
